export const PASSWORD_CHANGE = 'PASSWORD_CHANGE'
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
export const PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE'
